import React from 'react';

import { Loader } from '@cowbell/ui';

/**
 * The public routes are imported by the entry chunk, so this page is loaded on demand, as the Risk Data page is: a
 * static import would take the form engine and its dependencies into the entry chunk.
 */
const ApplicationFlowPage = React.lazy(() =>
  import('./ApplicationFlowPage').then((module) => ({
    default: module.ApplicationFlowPage,
  }))
);

export function LazyApplicationFlowPage() {
  return (
    <React.Suspense fallback={<Loader />}>
      <ApplicationFlowPage />
    </React.Suspense>
  );
}
